import type { Maybe } from '@adornis/base/utilTypes.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { GroupsAPI } from '../groups/api/GroupsAPI.js';
import { School } from '../groups/entities/School.js';
import { registerCache } from './entity-cache.js';

export const SCHOOL_CACHE_KEY = 'schools';

export interface SchoolCacheData {
  _class: string;
  _id: string;
  name: string;
  kuerzel: string;
  bundesland: string;
  isSgSchool: boolean;
  accountingNumber: Maybe<string>;
}

export function registerSchoolCache() {
  registerCache(SCHOOL_CACHE_KEY, {
    serverCachingFunction: async () => {
      const col = await getRawCollection(School._collectionName);
      return col
        .find(
          {
            _class: School._class,
          },
          {
            projection: {
              _class: 1,
              _id: 1,
              name: 1,
              bundesland: 1,
              isSgSchool: 1,
              accountingNumber: 1,
              kuerzel: 1,
            },
          },
        )
        .toArray();
    },
    clientCachingFunction: async () => {
      const schools = await GroupsAPI.getAllSchools()({
        _class: 1,
        _id: 1,
        name: 1,
        bundesland: 1,
        isSgSchool: 1,
        accountingNumber: 1,
        kuerzel: 1,
      });
      return schools.map(school => ({
        _class: school._class,
        _id: school._id,
        name: school.name,
        bundesland: school.bundesland,
        isSgSchool: school.isSgSchool,
        accountingNumber: school.accountingNumber,
        kuerzel: school.kuerzel,
      }));
    },
  });
}
